import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    Renderer2,
} from '@angular/core';

import {
    SortColumn,
    SortDirection,
    SortEvent,
} from '../models/sort-event-model';

const rotate: { [key: string]: SortDirection } = {
    asc: 'desc',
    desc: 'asc',
};

export function compare(
    v1: string | number | boolean | Date,
    v2: string | number | boolean | Date,
): number {
    if (v1 == null) return -1;
    if (v2 == null) return 1;
    if (v1 > v2) return 1;
    if (v1 < v2) return -1;
    return 0;
}

@Directive({
    selector: 'th[sortable]',
    host: {
        '(click)': 'rotate()',
    },
})
export class SortableHeaderDirective {
    @Input() sortable: SortColumn = '';
    @Input() direction: SortDirection = 'asc';
    @Input() index: number = 0;
    @Output() sort = new EventEmitter<SortEvent>();

    constructor(
        private readonly renderer: Renderer2,
        private readonly elRef: ElementRef,
    ) {}

    rotate(): void {
        const child: HTMLElement[] =
            this.elRef.nativeElement.parentElement.children;
        this.direction = rotate[this.direction];
        child.forEach((element) => {
            const list = element.classList.value.split(' ');
            const result = list.filter(
                (cls) =>
                    cls.toLowerCase().includes('desc') ||
                    cls.toLowerCase().includes('asc'),
            );
            if (result?.length > 0) {
                this.renderer.setAttribute(element, 'class', '');
            }
        });
        if (this.direction === 'desc') {
            this.renderer.addClass(
                this.elRef.nativeElement,
                `desc-${this.index}`,
            );
        } else {
            this.renderer.setAttribute(
                this.elRef.nativeElement,
                'class',
                `asc-${this.index}`,
            );
        }
        this.sort.emit({
            column: this.sortable,
            direction: this.direction,
            index: this.index,
        });
    }
}
